"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _calculatePerSet = require("./calculatePerSet");
Object.keys(_calculatePerSet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculatePerSet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _calculatePerSet[key];
    }
  });
});
var _calculatePosition = require("./calculatePosition");
Object.keys(_calculatePosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _calculatePosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _calculatePosition[key];
    }
  });
});
